<template>
    <ASelect
        mode="multiple"
        v-model:value="valueState"
        placeholder="Pilih Toko"
        allow-clear
        show-search
        :not-found-content="state.loading ? undefined : 'Tidak ditemukan'"
        option-filter-prop="label"
        option-label-prop="label"
        @search="onSearch"
        @blur="() => (state.params.q = null)"
        @select="() => (state.params.q = null)"
        v-bind="$attrs"
        :filter-option="false"
        :loading="state.loading"
        :show-arrow="true"
        style="width:300px">
        <ASelectOption v-for="item in state.data" :key="item.code" :label="getLabel(item)">
            <span v-html="highlight(getLabel(item))"></span>
        </ASelectOption>
        <template v-if="state.loading" #notFoundContent>
            <ASpin size="small" />
        </template>
    </ASelect>
</template>

<script>
import { onMounted, reactive, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce, keyBy, merge, pickBy, values } from 'lodash'

export default {
    props: {
        value: {
            type: [Array, Number, Object, String],
            default: null,
        },
        active: {
            type: [String, Number],
            default: () => 1,
        },
        vendor_id: {
            type: [Array, String, Number],
            default: () => null,
        },
        joinOptions: {
            type: [Array],
            default: () => [],
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const state = reactive({
            endpoint: `/api/filter/customer`,
            loading: false,
            data: [],
            params: {
                q: '',
                active: props.active,
                vendor_id: props.vendor_id,
            },
        })

        const fetchData = () => {
            state.loading = true
            apiClient.get(state.endpoint, { params: pickBy(state.params) })
                .then(({ data }) => {
                    const options = props.joinOptions.filter(item => item.code !== undefined)
                    if (options.length > 0) {
                        data = values(merge(keyBy(options, 'code'), keyBy(data, 'code')))
                    }
                
                    state.data = data
                })
                .finally(() => {
                    state.loading = false
                })
        }

        const getLabel = (item) => {
            let label = item.code + ' - ' + item.name

            return label
        }

        onMounted(() => {
            fetchData()
        })

        watch(() => props.vendor_id, () => {
            state.params.vendor_id = props.vendor_id
        })

        watch(state.params, debounce(() => {
            fetchData()
        }, 300))

        const onSearch = value => {
            state.params.q = value
        }

        const highlight = value => {
            return value.replace(new RegExp(state.params.q, 'gi'), match => {
                return `<span style="background-color: yellow;">${match}</span>`
            })
        }

        return {
            state,
            valueState: useVModel(props, 'value'),
            highlight,
            onSearch,
            getLabel,
        }
    },
}
</script>